import { register } from 'async-ops';
import { getDefaultOptions, throwExceptionErrors } from '../../../utils/fetch';
import { callMdaePublicApi } from "../../../call-web-api";

export const LOCK_DOCUMENT = 'LOCK_DOCUMENT';

export interface LockDocumentResponse {
  isLocked: boolean;
  // Milliseconds until the current holder's idle timeout elapses. Populated
  // even on rejection so the waiting user can see a countdown ("try again in
  // 3:42 minutes"). No user name is returned by design.
  msRemaining?: number;
  // Total configured idle timeout in ms — the editor uses this to size its
  // passive expiry timer to match the current server config (which is
  // per-environment via appsettings.*.json).
  idleTimeoutMs?: number;
}

export const service = async (data): Promise<LockDocumentResponse> => {
  const response: any = await callMdaePublicApi({
    type: 'post',
    contentType: 'application/json',
    url: '/Api/Document/LockDocument',
    isRoutedApiCall: true,
    ...getDefaultOptions(),
    body: JSON.stringify(data)
  });
  throwExceptionErrors(response);
  return response;
};

const mock = () => Promise.resolve({ isLocked: true, msRemaining: 300000 });

register(LOCK_DOCUMENT, service, mock);
